/**
 * <TutorConversationPage> — l'onglet Messages de la fiche d'un élève (page).
 *
 * La route `messenger` côté tuteur (`ChatScreen.js` + `CommonChat.js`), sur le socle de conversation de
 * l'élève, `<StudentTutorConversationPage>` retournée : l'élève à la place du tuteur (`person`, le rond
 * simple), sans en-tête, celui de la fiche le dit déjà. Le fil (jours, salves, le tuteur à droite, l'élève
 * cité avec son avatar), puis le composeur. Une notification « messages » ouvre la fiche sur cet onglet.
 *
 * Ce que le fil du tuteur a de plus que celui de l'élève passe par les effets de l'écran :
 *  - toucher une photo ou un document de l'élève (`onOpenAttachment`) ouvre la fiche de l'activité
 *    qui en est née, ou, s'il n'y en a pas, son aperçu avec « Créer une activité »
 *    (`<TutorMediaPreviewModal>`) ; la pastille d'une activité déjà tirée est posée sur la pièce
 *    (`activityStatus`, le `DoneChip` du legacy) ;
 *  - une photo ou un PDF choisi dans le composeur passe par le même aperçu, « Nouveau fichier »,
 *    avec « Créer une activité » et « Envoyer dans le chat ».
 *
 * La somme des non-lus de tous les élèves, à droite de l'ancien en-tête, est le badge de l'onglet
 * « Mes élèves ». La ligne « connecté / non connecté » ne revient pas : rien ne la mettait jamais à jour.
 *
 * Contrôlée : le fil arrive groupé, le brouillon, l'envoi et la pièce qui part aussi.
 */
import React from "react"

import {
    StudentTutorConversationPage,
    type StudentTutorConversationPageProps,
} from "../StudentTutorConversationPage/StudentTutorConversationPage"
import { type UITutorStudent } from "../../../ports/primary/ui/types/tutorEleves"

export type TutorConversationPageProps = Omit<
    StudentTutorConversationPageProps,
    "tutor" | "person" | "caption" | "onBack" | "hideHeader"
> & {
    /** L'élève à qui le tuteur parle. */
    student: UITutorStudent
}

export function TutorConversationPage(props: TutorConversationPageProps) {
    const { student, ...conversation } = props
    return (
        <StudentTutorConversationPage
            {...conversation}
            hideHeader
            person={{ name: student.name, avatarUrl: student.avatarUrl }}
        />
    )
}
